import script from "./AddCustomerTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomerTemplate.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomerTemplate.vue?vue&type=style&index=0&id=6c9f5ffc&lang=scss&scoped=true"
import "./AddCustomerTemplate.vue?vue&type=style&index=1&id=6c9f5ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9f5ffc"]])

export default __exports__